import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _isFunction from "lodash/isFunction";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
} // https://auth0.com/docs/libraries/auth0-spa-js
// https://auth0.com/docs/quickstart/spa/react/01-login
// https://auth0.com/docs/quickstart/spa/react/02-calling-an-api


import React, { useEffect, useContext, createContext, useState, useCallback } from "react";
import createAuth0Client from "@auth0/auth0-spa-js";
import URI from "urijs";
import { DEFAULT_API_URL } from "../config";
var AuthContext = createContext();
export var Provider = function Provider(_ref) {
  var _ref$apiUrl = _ref.apiUrl,
      apiUrl = _ref$apiUrl === void 0 ? DEFAULT_API_URL : _ref$apiUrl,
      clientId = _ref.clientId,
      children = _ref.children,
      navigate = _ref.navigate;

  if (!_isFunction(children)) {
    throw new Error("Children of AuthProvider must be a render function that takes the access token accessor. See https://www.runly.io/docs/integration/js/");
  }

  var _useState = useState({
    client: null,
    isAuthenticated: false
  }),
      auth = _useState[0],
      setAuth = _useState[1];

  useEffect(function () {
    function initClient() {
      return _initClient.apply(this, arguments);
    }

    function _initClient() {
      _initClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$yield$fetch$js, _yield$yield$fetch$js2, authority, audience, c, uri, _yield$c$handleRedire, appState, isAuthenticated;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(apiUrl);

              case 2:
                _context.next = 4;
                return _context.sent.json();

              case 4:
                _yield$yield$fetch$js = _context.sent;
                _yield$yield$fetch$js2 = _yield$yield$fetch$js.auth;
                authority = _yield$yield$fetch$js2.authority;
                audience = _yield$yield$fetch$js2.audience;
                _context.next = 10;
                return createAuth0Client({
                  domain: URI(authority).hostname(),
                  client_id: clientId,
                  audience: audience
                });

              case 10:
                c = _context.sent;
                uri = URI();

                if (!(uri.hasQuery("code") && uri.hasQuery("state"))) {
                  _context.next = 21;
                  break;
                }

                _context.next = 15;
                return c.handleRedirectCallback();

              case 15:
                _yield$c$handleRedire = _context.sent;
                appState = _yield$c$handleRedire.appState;
                setAuth({
                  client: c,
                  isAuthenticated: true
                });
                if (appState && navigate) navigate(appState);
                _context.next = 25;
                break;

              case 21:
                _context.next = 23;
                return c.isAuthenticated();

              case 23:
                isAuthenticated = _context.sent;
                setAuth({
                  client: c,
                  isAuthenticated: isAuthenticated
                });

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _initClient.apply(this, arguments);
    }

    initClient();
  }, [apiUrl, clientId, navigate]);
  var client = auth.client;
  var getAccessToken = useCallback(function () {
    return client === null || client === void 0 ? void 0 : client.getTokenSilently();
  }, [client]);
  return /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: auth
  }, children(getAccessToken));
};
export var useAuth = function useAuth() {
  var auth = useContext(AuthContext);

  if (!auth) {
    throw new Error("Missing Runly Auth context. Make sure to include an AuthProvider component up your component tree with your client ID.");
  }

  return auth;
};